import React, { useState } from 'react';
import crossIcon from '../../../assets/nach-cancellation/crossIcon.svg';
import { FullScreenBackdropLoader } from '../../../fibe-ui';
import { useAuthStore } from '../../../redux';
import { useNachCancellationStore } from '../../../redux/features/nachCancellationSlice';
import { APP_ID, APP_VERSION } from '../../../utils';
import { validatePan, validatePanInput } from '../../../utils/validations';
import sendOTPExistingCustomerAPICall from '../helpers/send-otp-existing-customer';
import { v4 as uuidv4 } from 'uuid';

const templateType = 'CANCEL_NACH';

const EnterPanDrawer = ({
  crossButtonClicked,
  handleDrawerState,
  handleLoadingState,
  autoFoucsDrawer,
}) => {
  const [panNumber, setPanNumber] = useState('');
  const [error, setError] = useState('');

  const { mobileNumber, updatePanNumber, updateMobileNumber } =
    useNachCancellationStore();

  const { customerId, customerRefNum, Authorization } = useAuthStore();
  let payload = {
    customerRefNum,
    appId: APP_ID,
    appVersion: APP_VERSION,
    requestId: uuidv4(),
    panNo: panNumber,
    templateType: templateType,
    isResendOtp: false,
  };
  const handleOtpClick = (panNumber) => {
    updatePanNumber(panNumber);
    if (!checkIsValidPan(panNumber)) {
      setError('Invalid pan number');
      return;
    }
    console.log(payload);
    handleLoadingState(true);
    sendOTPExistingCustomerAPICall({
      customerCredentials: {
        customerId,
        Authorization,
        customerRefNum,
      },
      payload: payload,
      successFn: (res) => {
        if (res?.statusCode !== 200) {
          setError(res.statusMsg);
        } else {
          handleDrawerState('OTP_DRAWER');
        }
      },
      errorFn: (e) => console.log(e),
      finallyFn: () => handleLoadingState(false),
    });
  };

  const checkIsValidPan = (panNumber) => {
    let isPanValid;
    validatePan(panNumber) ? (isPanValid = true) : (isPanValid = false);
    return isPanValid;
  };

  const handleInputChange = (e) => {
    setError('');
    let panNumberCapital = e.target.value.trim().toUpperCase();
    if (panNumberCapital.length != 0) {
      let panNumberWithoutSpecialChar = '';
      [...panNumberCapital].forEach((panDigit) => {
        if (validatePanInput(panDigit)) {
          panNumberWithoutSpecialChar += panDigit;
        }
      });
      setPanNumber(panNumberWithoutSpecialChar.slice(0, 10));
      return;
    }
    setPanNumber(panNumberCapital.slice(0, 10));
  };

  return (
    <>
      <div className="res150-overlay absolute top-0 left-0 right-0 bottom-0 w-full h-full  bg-gray-700 opacity-75 z-[100]"></div>
      <div className="relative z-[110] h-full bg-white flex-col md:flex-row">
        <div className="flex items-center justify-between border-b border-stroke p-5">
          <h3 className="text-lg text-text-primary">Verify PAN</h3>
          <img
            className="cursor-pointer"
            onClick={crossButtonClicked}
            src={crossIcon}
            alt="crossIcon"
          />
        </div>
        <div className="p-5">
          <h3 className="text-text-secondary text-base mb-5">
            Enter your PAN number
          </h3>
          <input
            onChange={handleInputChange}
            name="panInput"
            className={`border ${
              error.length >= 1
                ? 'border-warning'
                : panNumber.length >= 1
                ? 'border-[#079F9F] caret-[#079F9F]'
                : 'border-stroke'
            } rounded w-full h-14 px-3 ${
              panNumber.length >= 1 ? 'uppercase' : null
            }`}
            placeholder="PAN number"
            value={panNumber}
            maxLength={10}
            ref={autoFoucsDrawer}
          />

          {error.length >= 1 && (
            <div className="flex flex-row">
              <div className="text-warning mt-2 ">{error}</div>
            </div>
          )}

          <button
            className={`${
              panNumber.length >= 1 ? 'bg-accent' : 'bg-background-stroke'
            } text-base text-white font-medium p-3 text-center rounded-md shadow-md w-full mt-4 ${
              panNumber.length >= 1 ? 'cursor-pointer' : 'cursor-no-drop'
            }`}
            onClick={() => handleOtpClick(panNumber)}
            disabled={panNumber.length >= 1 ? false : true}
          >
            Get OTP
          </button>
        </div>
      </div>
    </>
  );
};

export default EnterPanDrawer;
